// Generated file : do not modify
export enum AdminObjActions
{
  NONE = 0,
  CREATE,
  UPDATE,
  DELETE
};

export enum AdminImportModes
{
  NONE = 0,
  COMPLETE,
  UPDATE
};

import { ListFilter } from '@/extend/classes/ListData';
import AdminAttrib from '@/extend/classes/AdminAttrib';
import { ExportType } from '@/extend/classes/Files';
import AdminInfo from '@/extend/classes/AdminInfo';
import ListData from '@/extend/classes/ListData';
import { HtmlParam } from '@/extend/classes/HtmlAttrib';
import { ObjTypes } from '@/generated/classes/ObjTypes';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Administration
export class AdminConfig {
  // 
  public fields: AdminAttrib[];
  // 
  public canCreate: boolean;
  // 
  public canImport: boolean;
  // 
  public exportTypes: ExportType[];
  // 
  public exportSelected: boolean;

  constructor() {
    this.fields = [];
    this.canCreate = false;
    this.canImport = false;
    this.exportTypes = [];
    this.exportSelected = false;
  }
}

export class AdminObj {
  // 
  public table: string;
  // 
  public action: AdminObjActions;
  // 
  public data: unknown;

  constructor() {
    this.table = '';
    this.action = AdminObjActions.NONE;
    this.data = null;
  }
}

export class AdminExport {
  // 
  public service: string;
  // 
  public table: string;
  // 
  public type: ExportType;
  // 
  public dataIds: number[];
  // 
  public attributes: string[];
  // 
  public possibleType: ExportType[];
  // 
  public exportSelected: boolean;

  constructor() {
    this.service = '';
    this.table = '';
    this.type = new ExportType();
    this.dataIds = [];
    this.attributes = [];
    this.possibleType = [];
    this.exportSelected = false;
  }
}

export class AdminImport {
  // 
  public service: string;
  // 
  public table: string;
  // 
  public acceptedTypes: string[];
  // 
  public mode: AdminImportModes;

  constructor() {
    this.service = '';
    this.table = '';
    this.acceptedTypes = [];
    this.mode = AdminImportModes.NONE;
  }
}

export default class Admin  {
  // Objet de rattachement
  public objType: ObjTypes;

  constructor() {
    this.objType = ObjTypes.NONE;
  }

  public static fromJson (obj: Admin): Admin {
    const newAdmin: Admin = new Admin();
    newAdmin.objType = obj.objType;
    return newAdmin;
  }

  public toJsonAdmin (): string {
    const json = {
      objType: this.objType,
    }
    return JSON.stringify(json);
  }

  public fromAdmin (obj: Admin): void {
    this.objType = obj.objType;
  }

  public compareAdmin (value: Admin): boolean {
    return (this.toJsonAdmin() == value.toJsonAdmin());
  }

  public cloneAdmin (): Admin {
    return Admin.fromJson(this);
  }

  public static listTableInfo (): Promise<AdminInfo[]> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/admins/listTableInfo', getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const cData: AdminInfo[] = [];
              res.data.forEach(( a: AdminInfo ) => {
                cData.push(a);
              })
              resolve(cData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static loadTable (listFilter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/admins/loadTable', listFilter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static loadConfig (table: string): Promise<AdminConfig> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/admins/loadConfig/' + table, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static loadAttribs (table: string): Promise<AdminAttrib[]> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/admins/loadAttribs/' + table, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const cData: AdminAttrib[] = [];
              res.data.forEach(( a: AdminAttrib ) => {
                cData.push(a);
              })
              resolve(cData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static updateTable (obj: AdminObj): Promise<unknown> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/admins/updateTable', obj, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static loadPubliParam (publiContext: string): Promise<HtmlParam[]> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/admins/loadPubliParam/' + publiContext, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const cData: HtmlParam[] = [];
              res.data.forEach(( a: HtmlParam ) => {
                cData.push(a);
              })
              resolve(cData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(admins: Admin[]) {
  }
}
